import * as Sentry from '@sentry/browser';
import React from 'react';

type AgentErrorBoundaryProps = {
	children: React.ReactNode;
};

type AgentErrorBoundaryState = {
	hasFailed: boolean;
};

// The panel, the past runs and the bell's agent rows render what an agent declares, so an agent that throws takes down
// only what it renders, not the page around it.
export class AgentErrorBoundary extends React.Component<AgentErrorBoundaryProps, AgentErrorBoundaryState> {
	static getDerivedStateFromError(): AgentErrorBoundaryState {
		return {
			hasFailed: true,
		};
	}

	state: AgentErrorBoundaryState = {
		hasFailed: false,
	};

	componentDidCatch(error: Error): void {
		Sentry.captureException(error);
	}

	render(): React.ReactNode {
		if (this.state.hasFailed) {
			return null;
		}
		return this.props.children;
	}
}
